interface Tokens {
  includeTopLevelNav: boolean;
}

const tokens: Tokens = {
  includeTopLevelNav: false,
};

export default tokens;
